/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UserDjSoftwareEnum = {
    Serato: 'serato',
    Virtualdj: 'virtualdj',
    Rekordbox: 'rekordbox',
    Other: 'other'
};
/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value) {
    return true;
}
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'djSoftware': json['dj_software'] == null ? undefined : json['dj_software'],
    };
}
export function UserToJSON(json) {
    return UserToJSONTyped(json, false);
}
export function UserToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'dj_software': value['djSoftware'],
    };
}
